const countryDict = [
	'Afghanistan',
	'Aland Islands', 
	'Albania',
	'Algeria',
	'American Samoa', 
	'Andorra',
	'Angola',
	'Anguilla',
	'Antarctica',
	'Antigua and Barbuda',
	'Argentina',
	'Armenia',
	'Aruba',
	'Australia',
	'Austria',
	'Azerbaijan',
	'Bahamas',
	'Bahrain',
	'Bangladesh',
	'Barbados',
	'Belarus',
	'Belgium',
	'Belize',
	'Benin',
	'Bermuda',
	'Bhutan',
	'Bolivia',
	'Bonaire, Sint Eustatius and Saba',
	'Bosnia and Herzegovina',
	'Botswana',
	'Bouvet Island', 
	'Brazil',
	'British Indian Ocean Territory',
	'Brunei Darussalam', 
	'Bulgaria',
	'Burkina Faso', 
	'Burundi',
	'Cambodia',
	'Cameroon',
	'Canada',
	'Cape Verde', 
	'Cayman Islands', 
	'Central African Republic',
	'Chad',
	'Chile',
	'China',
	'Christmas Island', 
	'Cocos (Keeling) Islands',
	'Colombia',
	'Comoros',
	'Congo',
	'Congo, The Democratic Republic of the',
	'Cook Islands', 
	'Costa Rica', 
	"Cote D'Ivoire",
	'Croatia',
	'Cuba',
	'Curacao',
	'Cyprus',
	'Czech Republic', 
	'Denmark',
	'Djibouti',
	'Dominica',
	'Dominican Republic', 
	'Ecuador',
	'Egypt',
	'El Salvador', 
	'Equatorial Guinea', 
	'Eritrea',
	'Estonia',
	'Ethiopia',
	'Falkland Islands (Malvinas)',
	'Faroe Islands', 
	'Fiji',
	'Finland',
	'France',
	'French Guiana', 
	'French Polynesia', 
	'French Southern Territories',
	'Gabon',
	'Gambia',
	'Georgia',
	'Germany',
	'Ghana',
	'Gibraltar',
	'Greece',
	'Greenland',
	'Grenada',
	'Guadeloupe',
	'Guam',
	'Guatemala',
	'Guernsey',
	'Guinea',
	'Guinea-Bissau',
	'Guyana',
	'Haiti',
	'Heard Island and McDonald Islands',
	'Holy See (Vatican City State)',
	'Honduras',
	'Hong Kong', 
	'Hungary',
	'Iceland',
	'India',
	'Indonesia',
	'Iran, Islamic Republic of',
	'Iraq',
	'Ireland',
	'Isle of Man',
	'Israel',
	'Italy',
	'Jamaica',
	'Japan',
	'Jersey',
	'Jordan',
	'Kazakhstan',
	'Kenya',
	'Kiribati',
	"Korea, Democratic People's Republic of",
	'Korea, Republic of',
	'Kuwait',
	'Kyrgyzstan',
	"Lao People's Democratic Republic",
	'Latvia',
	'Lebanon',
	'Lesotho',
	'Liberia',
	'Libya',
	'Liechtenstein',
	'Lithuania',
	'Luxembourg',
	'Macao',
	'Macedonia',
	'Madagascar',
	'Malawi',
	'Malaysia',
	'Maldives',
	'Mali',
	'Malta',
	'Marshall Islands', 
	'Martinique',
	'Mauritania',
	'Mauritius',
	'Mayotte',
	'Mexico',
	'Micronesia',
	'Moldova, Republic of',
	'Monaco',
	'Mongolia',
	'Montenegro',
	'Montserrat',
	'Morocco',
	'Mozambique',
	'Myanmar',
	'Namibia',
	'Nauru',
	'Nepal',
	'Netherlands',
	'New Caledonia', 
	'New Zealand', 
	'Nicaragua',
	'Niger',
	'Nigeria',
	'Niue',
	'Norfolk Island', 
	'Northern Mariana Islands',
	'Norway',
	'Oman',
	'Pakistan',
	'Palau',
	'Palestine, State of',
	'Panama',
	'Papua New Guinea',
	'Paraguay',
	'Peru',
	'Philippines',
	'Pitcairn',
	'Poland',
	'Portugal',
	'Puerto Rico', 
	'Qatar',
	'Reunion',
	'Romania',
	'Russian Federation', 
	'Rwanda',
	'Saint Barthelemy', 
	'Saint Helena, Ascension and Tristan Da Cunha',
	'Saint Kitts and Nevis',
	'Saint Lucia', 
	'Saint Martin (French Part)',
	'Saint Pierre and Miquelon',
	'Saint Vincent and the Grenadines',
	'Samoa',
	'San Marino', 
	'Sao Tome and Principe',
	'Saudi Arabia', 
	'Senegal',
	'Serbia',
	'Seychelles',
	'Sierra Leone', 
	'Singapore',
	'Sint Maarten (Dutch Part)',
	'Slovakia',
	'Slovenia',
	'Solomon Islands', 
	'Somalia',
	'South Africa', 
	'South Georgia and the South Sandwich Islands',
	'South Sudan', 
	'Spain',
	'Sri Lanka', 
	'Sudan',
	'Suriname',
	'Svalbard and Jan Mayen',
	'Swaziland',
	'Sweden',
	'Switzerland',
	'Syrian Arab Republic',
	'Taiwan',
	'Tajikistan',
	'Tanzania, United Republic of',
	'Thailand',
	'Timor-Leste',
	'Togo',
	'Tokelau',
	'Tonga',
	'Trinidad and Tobago',
	'Tunisia',
	'Turkey',
	'Turkmenistan',
	'Turks and Caicos Islands',
	'Tuvalu',
	'Uganda',
	'Ukraine',
	'United Arab Emirates',
	'United Kingdom', 
	'United States',
	'United States Minor Outlying Islands',
	'Uruguay',
	'Uzbekistan',
	'Vanuatu',
	'Venezuela',
	'Viet Nam', 
	'Virgin Islands, British',
	'Virgin Islands, U.S.',
	'Wallis and Futuna',
	'Western Sahara', 
	'Yemen',
	'Zambia',
	'Zimbabwe']

export const getCountries = () => {
    return countryDict
}


// WEBPACK FOOTER //
// ./src/components/FundAdd/countries.js